import { formatPrismicData } from '@monofront/business/utils';
import { IBrandsLogoList } from './BrandsLogoList';

export const mapBrandslogoList = ({ prismicContent }): IBrandsLogoList => {
  const { primary, items }: IBrandsLogoList = formatPrismicData(
    prismicContent,
    ['collection'],
  );

  return {
    primary,
    items,
  };
};
